/**
 * Home banner ultra – miniatury 1:1 pod banerem, przełączanie slajdów.
 */
(function () {
  function initHomeBannerUltra(section) {
    if (!section) return;

    const slider = section.querySelector('css-slider');
    const thumbs = section.querySelectorAll('.home-banner-ultra__thumb');
    if (!thumbs.length) return;

    const setActive = (index) => {
      const i = parseInt(index, 10);
      thumbs.forEach((thumb, n) => {
        const active = n === i;
        thumb.classList.toggle('active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };

    thumbs.forEach((thumb) => {
      if (thumb.dataset.hbuBound === 'true') return;
      thumb.dataset.hbuBound = 'true';
      thumb.addEventListener('click', () => {
        const index = parseInt(thumb.dataset.index, 10);
        if (Number.isNaN(index)) return;

        if (slider && slider.sliderEnabled) {
          slider.changeSlide(index);
        } else {
          const slide = section.querySelector(
            `.home-banner-ultra__slide[data-slide-index="${index}"]`
          );
          if (slide) {
            slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          }
        }
        setActive(index);
      });
    });

    const bindSlider = () => {
      if (!slider) return;
      slider.addEventListener('change', (e) => {
        if (typeof e.target.index !== 'undefined') {
          setActive(e.target.index);
        }
      });
      if (typeof slider.index !== 'undefined') {
        setActive(slider.index);
      }
    };

    if (slider) {
      if (slider.sliderEnabled) {
        bindSlider();
      } else {
        slider.addEventListener('ready', bindSlider, { once: true });
      }
    }

  }

  function initAll(root) {
    (root || document)
      .querySelectorAll('[data-home-banner-ultra]')
      .forEach(initHomeBannerUltra);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.classList.contains('section-home-banner-ultra')) {
      initAll(e.target);
    }
  });
})();
